import { Injectable } from '@angular/core';
import { ContentfulService } from 'src/app/shared/services/contentful.service';
import { Entry } from 'contentful';
import { ContentFulModel } from 'src/app/shared/models/contentfulmodel';
import { BehaviorSubject } from 'rxjs';
import { PageId } from 'src/app/shared/utilities/pageids.enum';
import { MetaService } from 'src/app/shared/services/meta.service';

@Injectable({
  providedIn: 'root',
})
export class CustomerspagesService {
  constructor(
    private contentful: ContentfulService,
    private meta: MetaService
  ) {}

  customersData: any;
  customersArticleData: any;

  private customersDataSubject$ = new BehaviorSubject<any>(null);
  public customersData$ = this.customersDataSubject$.asObservable();
  private customersArticleDataSubject$ = new BehaviorSubject<any>(null);
  public customersArticleData$ =
    this.customersArticleDataSubject$.asObservable();

  getCustomersData() {
    this.contentful
      .getEntries(
        Object.assign({
          content_type: PageId.customersLandingPage,
          include: 10,
        })
      )
      .then(res => {
        let mod = res.items as Entry<any>[];
        this.customersData = mod[0].fields;
        const whiteaperData = this.customersData;
        if (whiteaperData) {
          this.customersDataSubject$.next(whiteaperData);
        }
      });
  }

  getArticleByID(query: any): Promise<Entry<any>[]> {
    return this.contentful
      .getEntries(
        Object.assign({
          access_token: PageId.accessToken,
          content_type: PageId.customerStoryArticlePage,
          include: 10,
          'fields.webPageId': query,
        })
      )
      .then(res => {
        return res.items;
      });
  }

  getArticleData(id: string) {
    this.getArticleByID(id).then(data => {
      if (data && data.length > 0 && data[0]?.fields) {
        this.customersArticleData = data[0].fields;
        this.customersArticleDataSubject$.next(this.customersArticleData);
      }
    }).catch(error => {
      console.error('Error fetching customer article data:', error);
    });
  }

  getAllCustomerStories(): Promise<Entry<any>[]> {
    return this.contentful
      .getEntries(
        Object.assign({
          access_token: PageId.accessToken,
          content_type: PageId.customerStoryArticlePage,
          include: 10,
        })
      )
      .then(res => {
        return res.items;
      });
  }
}
